// File Metadata:
// Filename: Task.js
// Version: 1.00
// Created: 2022-11-28 21:56:48
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React from 'react'
import { Avatar, Card, CardActions, CardContent, CardHeader, Grid, Paper, Stack } from '@mui/material'
import StyledBadge from './StyledBadge'
import AssignmentIcon from '@mui/icons-material/Assignment'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { Link } from 'react-router-dom'
import { red, green, orange } from '@mui/material/colors'
import { styled } from '@mui/material/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFor } from '@fortawesome/free-solid-svg-icons'
import { format } from 'date-fns'

const Task = ({ id, type, data }) => {
	const style = {
		'& .MuiCardHeader-root': {
			backgroundColor: '#005ca9'
		},
		//'backgroundColor': '#005ca9',
		'& .MuiCardHeader-title': {
			color: '#000'
		},
		'& .MuiCardHeader-subheader': {
			color: '#000'
		}
	}

	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === 'dark' ? '#005ca9' : '#fff',
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: 'center',
		color: theme.palette.text.primary
	}))

	let content = null
	let taskStatus

	if (type === 'reception') {
		taskStatus = !data.goodsReceipt ? red[500] : 
					!data.putawayStatus ? orange[500] : 
					green[500]

		content = (
			<Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
				<Card variant='elevation'>
					<CardHeader
						avatar={
							<StyledBadge
								color='secondary'
								overlap='circular'
								anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
								variant='dot'
								taskStatus={taskStatus}
							>
								<Link to={`/dash/receptions/${id}`}>
									<Avatar sx={{ bgcolor: '#005ca9' }}>
										<AssignmentIcon sx={{ color: '#FFF' }} />
									</Avatar>
								</Link>
							</StyledBadge>
						}
						title={`Reception #${data.reception}`}
						subheader={data.deliveryDate}
						sx={style}
					/>
					<CardContent>
						<Stack spacing={1}>
							<Item>Tour: {data.tourNumber}</Item>
							<Item>{data.vendorName} / {data.vendorNumber}</Item>
							<Item>Location: {data.unloadLocation}</Item>
						</Stack>
					</CardContent>
				</Card>
			</Grid>
		)
	} else if (type === 'shipment') {
		taskStatus = data.completed ? green[500] : orange[500]

		content = (
			<Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
				<Card variant='elevation'>
					<CardHeader
						avatar={
							<StyledBadge
								color='secondary'
								overlap='circular'
								anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
								variant='dot'
								taskStatus={taskStatus}
							>
								<Link to={`/dash/shipments/${id}`}>
									<Avatar sx={{ bgcolor: '#1976d2' }}>
										<LocalShippingIcon sx={{ color: '#FFF' }} />
									</Avatar>
								</Link>
							</StyledBadge>
						}
						title={`Shipment ${data.type}`}
						subheader={format(new Date(data.createdAt), 'dd-MM-yyyy')}
						sx={style}
					/>
					<CardContent>
						<Stack spacing={1}>
							<Item>SSCC: {data.sscc}</Item>
							<Item>Tour: {data.tour || 'N/A'}</Item>
						</Stack>
					</CardContent>
				</Card>
			</Grid>
		)
	}

	return content
}

export default Task
